import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { StorePhysicianDataAction, StoreStaffDataAction } from "./physicians-data.action";

@State<any>({
  name: 'PhysiciansList',
  defaults: {
    physicians: [],
    staffs: []
  }
})

@Injectable()

export class StorePhysicianDataState {
  @Selector() static getPhysiciansAndStaffs(state: any) {
    return state;
  }

  @Action(StorePhysicianDataAction) updatePhysiciansList(
    { getState, patchState }: StateContext<any>,
    { payload }
  ) {
 //   console.log(payload);
    const state = getState();

    patchState({
      physicians: payload
    });
  }

  @Action(StoreStaffDataAction) updateStaffsList(
    { getState, patchState }: StateContext<any>,
    { payload }
  ) {
    const state = getState();

    patchState({
      staffs: payload
    })
  }
}